<template>
  <section id="section-print" v-if="formulario && formulario.id">
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="forceDownload"
      :preview-modal="!forceDownload"
      :filename="`Comprovante de inscrição nº ${formulario?.id || ''}`"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <div slot="pdf-content">
        <div class="px-5 pt-2">
          <div class="row justify-content-center">
            <div class="col-12 pb-1 text-center">
              <img class="img-brasao" src="../assets/images/logo.png" />
            </div>

            <div class="col-12">
              <h5 class="text-center font-17">Prefeitura Municipal De {{ formulario.concurso?.prefeitura || '--' }}</h5>
              <p class="text-center font-13">
                {{ formulario.concurso?.titulo || "PROCESSO SELETIVO PÚBLICO" }}
              </p>
            </div>

            <div class="col-12 mb-4">
              <h4 class="text-center" style="font-size: 15px">PROTOCOLO DE INSCRIÇÃO</h4>
            </div>

            <!-- Dados da Inscrição -->
            <div class="col-4">
              <p><span>Número:</span> {{ mountNumInsc(formulario.id) || '--' }}</p>
            </div>
            <div class="col-8">
              <p><span>Data de inscrição:</span> {{ mountDateTime(formulario.created_at) }}</p>
            </div>

            <!-- Dados do Candidato -->
            <div class="col-12 bg-light p-2">
              <p class="mb-2 font-weight-bold">DADOS PESSOAIS</p>
              <p><span>Nome:</span> {{ formulario.cadastro?.nome || '--' }}</p>
              <p><span>CPF:</span> {{ formatCPF(formulario.cadastro?.cpf) }}</p>
              <p><span>RG:</span> {{ formulario.cadastro?.rg }} - {{ formulario.cadastro?.rg_orgao_emissor }}</p>
              <p><span>Data de Nascimento:</span> {{ mountDate(formulario.cadastro?.data_nascimento) }}</p>
              <p><span>Telefone:</span> {{ mountPhone(formulario.cadastro?.telefone_celular) }}</p>
              <p><span>Email:</span> {{ formulario.cadastro?.email || '--' }}</p>
              <p><span>Endereço:</span> {{ formulario.cadastro?.endereco }}, Nº {{ formulario.cadastro?.numero }} - {{ formulario.cadastro?.bairro }}, {{ formulario.cadastro?.cidade }}/{{ formulario.cadastro?.uf }}</p>
            </div>

            <!-- Dados de Deficiência e Condição Especial -->
            <div class="col-12 bg-light p-2" v-if="formulario.possui_deficiencia === 'S' || formulario.possui_condicao_especial === 'S'">
              <p class="mb-2 font-weight-bold">NECESSIDADES ESPECIAIS</p>
              <p v-if="formulario.possui_deficiencia === 'S'">
                <span>Pessoa com Deficiência (PCD):</span> Sim
              </p>
              <p v-if="formulario.detalhe_deficiencia">
                <span>Detalhes da Deficiência:</span> {{ formulario.detalhe_deficiencia }}
              </p>
              <p v-if="formulario.possui_condicao_especial === 'S'">
                <span>Condição Especial para Prova:</span> Sim
              </p>
              <p v-if="formulario.detalhe_condicao_especial">
                <span>Detalhes da Condição Especial:</span> {{ formulario.detalhe_condicao_especial }}
              </p>
            </div>

            <!-- Dados da Vaga -->
            <div class="col-12 bg-light p-2">
              <p class="mb-2 font-weight-bold">DADOS DA INSCRIÇÃO</p>
              <p><span>Cargo:</span> {{ formulario.vaga?.cargo || '--' }}</p>
              <!-- <p><span>Descrição:</span> {{ formulario.vaga?.descricao || '--' }}</p> -->
              <p><span>Valor da Inscrição:</span> R$ {{ formulario.vaga?.valor_inscricao || '--' }}</p>
              <p><span>Situação:</span> {{ formatarSituacao(formulario.situacao) || '--' }}</p>
              <p v-if="formulario.local_prova"><span>Local de Prova:</span> {{ formulario.local_prova }}</p>
            </div>

            <!-- Dados do Processo Seletivo -->
            <div class="col-12 bg-light p-2">
              <p class="mb-2 font-weight-bold">INFORMAÇÕES DO PROCESSO SELETIVO</p>
              <p><span>Prefeitura:</span> {{ formulario.concurso?.prefeitura || '--' }}</p>
              <p><span>Período de Inscrição:</span> {{ mountDate(formulario.concurso?.data_prazo_inicio) }} até {{ mountDate(formulario.concurso?.data_prazo_fim) }}</p>
              <p><span>Status:</span> {{ formulario.concurso?.status || '--' }}</p>
            </div>
          </div>
        </div>
      </div>
    </vue-html2pdf>
  </section>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'ComprovanteInscricao',
  components: {
    VueHtml2pdf
  },
  props: {
    formulario: {
      type: Object,
      required: false,
      default: () => ({})
    },
    forceDownload: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    mountNumInsc(num) {
      return `${num}`?.padStart(6, '0')
    },

    mountDate(date) {
      if (!date) return '--'
      
      try {
        // Se a data vier apenas com a data (sem hora), usar diretamente
        if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [year, month, day] = date.split('-')
          return `${day}/${month}/${year}`
        }
        
        // Tratar formato do banco: YYYY-MM-DD HH:mm:ss (com espaço)
        if (typeof date === 'string') {
          let dateString = date.replace('Z', '')
          
          // Se tiver formato com espaço (formato do banco: YYYY-MM-DD HH:mm:ss)
          if (dateString.match(/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/)) {
            const [datePart] = dateString.split(' ')
            const [year, month, day] = datePart.split('-')
            return `${day}/${month}/${year}`
          }
          
          // Para datas ISO com timezone, remover o 'Z' e tratar como local
          if (dateString.includes('T')) {
            // Remover o 'Z' do final se existir e tratar como hora local
            dateString = dateString.replace('Z', '')
            // Se tiver apenas data e hora sem timezone, usar diretamente
            if (dateString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
              const [datePart] = dateString.split('T')
              const [year, month, day] = datePart.split('-')
              // Retornar apenas a data, ignorando a hora
              return `${day}/${month}/${year}`
            }
          }
        }
        
        // Criar a data e formatar no fuso horário local
        const dateObj = new Date(date)
        
        // Verificar se a data é válida
        if (isNaN(dateObj.getTime())) return '--'
        
        // Usar métodos locais para evitar conversão UTC
        const day = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0')
        const year = dateObj.getFullYear()
        
        return `${day}/${month}/${year}`
      } catch (error) {
        console.error('Erro ao formatar data:', error)
        return '--'
      }
    },

    mountDateTime(date) {
      if (!date) return '--'
      
      try {
        // Se a data vier apenas com a data (sem hora), usar diretamente
        if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [year, month, day] = date.split('-')
          return `${day}/${month}/${year} 00:00`
        }
        
        // Tratar formato do banco: 2025-11-25 07:53:15.000
        if (typeof date === 'string') {
          // Remover o 'Z' do final se existir (formato ISO)
          let dateString = date.replace('Z', '')
          
          // Se tiver formato com espaço (formato do banco: YYYY-MM-DD HH:mm:ss)
          if (dateString.match(/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/)) {
            const [datePart, timePart] = dateString.split(' ')
            const [year, month, day] = datePart.split('-')
            const [hours, minutes] = timePart.split(':')
            return `${day}/${month}/${year} ${hours}:${minutes}`
          }
          
          // Se tiver formato ISO com T (YYYY-MM-DDTHH:mm:ss)
          if (dateString.includes('T')) {
            const [datePart, timePart] = dateString.split('T')
            const [year, month, day] = datePart.split('-')
            const [hours, minutes] = timePart.split(':')
            return `${day}/${month}/${year} ${hours}:${minutes}`
          }
        }
        
        // Fallback: usar Date object apenas se necessário
        const dateObj = new Date(date)
        
        // Verificar se a data é válida
        if (isNaN(dateObj.getTime())) return '--'
        
        // Usar métodos locais para evitar conversão UTC
        const day = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0')
        const year = dateObj.getFullYear()
        const hours = String(dateObj.getHours()).padStart(2, '0')
        const minutes = String(dateObj.getMinutes()).padStart(2, '0')
        
        return `${day}/${month}/${year} ${hours}:${minutes}`
      } catch (error) {
        console.error('Erro ao formatar data/hora:', error)
        return '--'
      }
    },

    mountPhone(phone) {
      if (!phone) return '--'

      // Manter apenas dígitos para evitar duplicar parênteses/traços
      const digits = String(phone).replace(/\D/g, '')
      if (!digits.length) return '--'

      const ddd = digits.slice(0, 2)

      // Celular com 11 dígitos: (DD) 9XXXX-XXXX
      if (digits.length === 11) {
        const numero = digits.slice(2)
        const first = numero.slice(0, 5)
        const second = numero.slice(5)
        return `(${ddd}) ${first}-${second}`
      }

      // Fixo com 10 dígitos: (DD) XXXX-XXXX
      if (digits.length === 10) {
        const first = digits.slice(2, 6)
        const second = digits.slice(6)
        return `(${ddd}) ${first}-${second}`
      }

      // Formato inesperado: devolve apenas os dígitos com DDD
      const first = digits.slice(2, 6)
      const second = digits.slice(6)
      return `(${ddd}) ${first}${second ? '-' + second : ''}`
    },

    formatCPF(cpf) {
      return cpf ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '--'
    },

    formatarSituacao(situacao) {
      if (!situacao) return '--'
      
      // Retornar a situação exatamente como vem da API, sem processamento
      return situacao
    },

    generatePdf() {
      this.$refs.html2Pdf.generatePdf()
    }
  }
}
</script>

<style lang="sass" scoped>
br
  margin-bottom: 10px
p, h1, h2, h3, h4, h5, h6
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important
p
  font-size: 11px
  color: #000 !important
  font-weight: 300 !important
  margin-bottom: 3px
  span
    font-size: 13px
    font-weight: 600 !important
    margin-right: 4px
.img-brasao
  width: 60px !important
.bg-light
  padding: 5px
  font-size: 12px
  font-weight: 500
</style>